import mwcMarketsCore from 'mwc-markets-core';
import Component from './src/time-sales.vue';

const { createCustomElement } = mwcMarketsCore;

export default createCustomElement(Component);
